export default {
  list: [],
  listAdmin: []
};
